<template>
    <div id="buyList">
        <div class="sectionHeader isFixed" ref="mainHeader" v-if="mShowHeader">
            <div class="">
                <mainHeader class="mainHeader"></mainHeader>
            </div>
        </div>
        <div class="headerIsShow" v-if="mShowHeader"></div>
        <div class="b-back">
            <span class="lable-title m-left">采购列表</span>
            <span class="lable-time m-right" @click="back()">返回上一页></span>
        </div>
        <div class="b-space"></div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import mainHeader from '@/view/header'
export default {
    name:'',
    components: {
        mainHeader
    },
    data () {
        return {
            mMsgList: [1,2],
            mShowHeader: true,
        }
    },
    methods: {
        back: function() {
            this.$router.back(-1)
        }
    },
    created () {
        if (this.$route.query.isApp == 1 && this.$route.query.type == 1) {
            localStorage.setItem('enterType', this.$route.query.type)
            localStorage.setItem('isApp', this.$route.query.isApp)
        }
        if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1) {
            this.mShowHeader = false
        } else {
            this.mShowHeader = true
        }
        console.log(this.mShowHeader)
    },
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2;')
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
    .sectionHeader {
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .sectionHeader.isFixed {
        position: fixed;
        top: 0px;
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .headerIsShow {
        margin-top: 55px;
    }
    .m-top {
        margin-top: 5px;
    }
    .m-left {
        margin-left: 13px;
    }
    .m-right {
        margin-right: 13px;
    }
    .b-back {
        height: 50px;
        display: flex;
        background-color: #ffffff;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .lable-title {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
    }
    .lable-time {
        color: #808080;
        font-size: 12px;
    }
    .b-space {
        height: 15px;
        background-color: #f2f2f2;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/view/procurement/buyList.vue